/**
 * The delegated-session sentinel and the JWT readers (sdk-source-of-truth
 * sdk ADR-010). The sentinel is a fact about the DAEMON holding the renewal
 * key: renderer-side material carries it in place of a `session_token`, so a
 * local renew is unrepresentable — renewal is an `authInfo()` re-fetch.
 */
import { decodeSessionJwt } from '../auth/decodeSessionJwt.js';

export const DELEGATED_SESSION_TOKEN = '__session_token_held_by_daemon__';

export function isDelegatedSessionToken(sessionToken: string): boolean {
  return sessionToken === DELEGATED_SESSION_TOKEN;
}

/** The epoch-seconds expiry a JWT carries, or null. */
export function expiresAtOfJwt(sessionJwt: string): number | null {
  return decodeSessionJwt(sessionJwt).exp;
}

/** Material for a holder that mirrors another process's credential (the
 *  desktop renderer mirroring the daemon). */
export function delegatedMaterial(sessionJwt: string): { session_jwt: string; session_token: string } {
  return { session_jwt: sessionJwt, session_token: DELEGATED_SESSION_TOKEN };
}
